import { https } from './https';
import { api_url } from './../Configuration/config';

//login
export async function adminLogin(data){
    return await https.post(`${api_url}admin/auth/login`, data);
}